import h5Pc from "../views/Pc";

export default [
  {
    path: "/",
    name: "h5Pc",
    component: h5Pc
  }
];
